<template>
	<Col class="height-100 flex-justify-space-between" :class="{ 'flex-justify-end': !allowShare, 'overflow-hidden': showLink }">
		<Col v-if="allowShare" class="inner-content-container px-2 pt-4 overflow-y-auto" :class="[showLink ? 'overflow-y-auto' : 'no-link']">
			<Col class="px-3">
				<Row class="flex-align-center flex-justify-space-between mb-3">
					<ShareFeatureDialogInnerTitle text="Share with teammates" />
					<PreviouslySharedWithIndicator v-if="isShortMode" v-on="$listeners" :workflowId="workflow.id" />
				</Row>
				<slot name="user-select-combobox" />
				<ShareFeatureDialogSpaceMembers v-if="!isShortMode" class="mb-3" :projectId="workflow.project" />
			</Col>
			<ExistingShareList v-if="!isShortMode" :workflow="workflow" />
		</Col>
		<ShareDialogToolDetails v-if="showLink" class="link-container" :workflow="workflow" />
	</Col>
</template>
<script>
import ExistingShareList from '@/components/dialogs/ShareFeatureDialog/ExistingShareList.vue';
import ShareDialogToolDetails from '@/components/dialogs/ShareFeatureDialog/ShareDialogToolDetails.vue';
import ShareFeatureDialogInnerTitle from '@/components/dialogs/ShareFeatureDialog/ShareFeatureDialogInnerTitle.vue';
import ShareFeatureDialogSpaceMembers from '@/components/dialogs/ShareFeatureDialog/ShareFeatureDialogSpaceMembers.vue';
import PreviouslySharedWithIndicator from '@/components/dialogs/ShareFeatureDialog/ExistingShareList/PreviouslySharedWithIndicator.vue';

export default {
	name: 'SharedWithTeammates',
	components: {
		ExistingShareList,
		ShareDialogToolDetails,
		ShareFeatureDialogInnerTitle,
		PreviouslySharedWithIndicator,
		ShareFeatureDialogSpaceMembers,
	},
	props: {
		workflow: { type: Object },
		showLink: { type: Boolean },
		allowShare: { type: Boolean },
		isShortMode: { type: Boolean },
	},
};
</script>
<style scoped lang="scss">
$link-container-height: 140px;
.link-container {
	border-top: 1px solid #e7e7ed;
	min-height: $link-container-height;
}
.inner-content-container {
	height: calc(100% - #{$link-container-height});
	&.no-link {
		height: 100%;
	}
}
</style>
